import { useEffect, useState } from "react";
import styles from "./TimeCountdown.module.scss";
import { setQuizExpired } from "../../../../redux/quizzes";
import { now } from "../../../../utils/time";
import { useDispatch, useSelector } from "../../../../hooks";

export const TimeCountdown = () => {
    const [timeLeft, setTimeLeft] = useState<number>();

    const { quiz, deltaTime } = useSelector(store => store.quiz);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!quiz)
            return;

        setTimeLeft(quiz.cooldown - now() + deltaTime);

        if (quiz.cooldown - now() + deltaTime <= 0) {
            dispatch(setQuizExpired(true));
            return;
        }

        const interval = setInterval(() => {
            setTimeLeft(prevTime => {
                if (prevTime === undefined)
                    return;

                const newTime = prevTime - 1;
                if (newTime <= 0)
                    clearInterval(interval);
                return newTime;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [quiz, deltaTime, dispatch]);

    useEffect(() => {
        if (timeLeft === undefined)
            return;

        if (timeLeft <= 0)
            dispatch(setQuizExpired(true));
    }, [timeLeft, dispatch])

    const getColor = () => {
        if (timeLeft === undefined)
            return;

        if (timeLeft > 15)
            return "#0F9DC3";
        else if (timeLeft > 7.5)
            return "#F1D045";

        return "#E06F4F";
    }
    
    return (
        <div className={styles.timeCont}>
            <div className={styles.timeAndProgressBarBlock}>
                <div className={styles.timerBlock}>
                    <span>Осталось</span>
                    <span className={styles.timer}>{timeLeft} сек</span>
                </div>

                <div className={styles.progressBar}>
                    <div
                        className={styles.progressFill}
                        style={{
                            width: `${((timeLeft ?? 0) / 30) * 100}%`,
                            backgroundColor: getColor(),
                        }}
                    />
                </div>
            </div>
        </div>
    );
}